import React, { useEffect, useRef, useState } from "react";
import "../DesignerRenderer.css";

const ObjectQuickMenu = ({
  object,
  canvasRef,
  onDuplicate,
  onDelete,
  onBringToFront,
  onSendToBack,
  onBringForward,
  onSendBackward,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [menuPos, setMenuPos] = useState({
    top: Math.max(10, (object?.y || 0) - 10),
    left: Math.max(10, (object?.x || 0) + (object?.width || 0) - 10),
  });

  useEffect(() => {
    if (!open) return;

    const canvasEl = canvasRef?.current;
    const dropdownEl = dropdownRef.current;
    if (!canvasEl || !dropdownEl || !object) return;

    const canvasWidth = canvasEl.clientWidth;
    const canvasHeight = canvasEl.clientHeight;
    const dropdownWidth = dropdownEl.offsetWidth;
    const dropdownHeight = dropdownEl.offsetHeight;

    const triggerSize = 28;
    const margin = 10;

    let left = (object.x || 0) + (object.width || 0) - 10;
    let top = (object.y || 0) - 10;

    const projectedRight = left + dropdownWidth;
    const projectedBottom = top + triggerSize + 6 + dropdownHeight;

    if (projectedRight > canvasWidth - margin) {
      left = canvasWidth - dropdownWidth - margin;
    }

    if (left < margin) {
      left = margin;
    }

    if (projectedBottom > canvasHeight - margin) {
      top = canvasHeight - (triggerSize + 6 + dropdownHeight) - margin;
    }

    if (top < margin) {
      top = margin;
    }

    setMenuPos({ top, left });
  }, [open, object, canvasRef]);

  return (
    <div
      className="dr-quick-menu"
      style={{
        top: `${menuPos.top}px`,
        left: `${menuPos.left}px`,
        zIndex: (object?.z_index ?? 0) + 1000,
      }}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className="dr-quick-menu-trigger"
        onClick={() => setOpen((prev) => !prev)}
        title="Object menu"
      >
        <span style={{ display: "block", transform: "translateY(-1px)" }}>⋯</span>
      </button>

      {open && (
        <div ref={dropdownRef} className="dr-quick-menu-dropdown">
          <button
            type="button"
            className="dr-quick-menu-item"
            onClick={() => {
              setOpen(false);
              onDuplicate?.(object.id);
            }}
          >
            Duplicate
          </button>

          <button
            type="button"
            className="dr-quick-menu-item"
            onClick={() => {
              setOpen(false);
              onBringForward?.(object.id);
            }}
          >
            Forward
          </button>

          <button
            type="button"
            className="dr-quick-menu-item"
            onClick={() => {
              setOpen(false);
              onSendBackward?.(object.id);
            }}
          >
            Backward
          </button>

          <button
            type="button"
            className="dr-quick-menu-item"
            onClick={() => {
              setOpen(false);
              onBringToFront?.(object.id);
            }}
          >
            To Front
          </button>

          <button
            type="button"
            className="dr-quick-menu-item"
            onClick={() => {
              setOpen(false);
              onSendToBack?.(object.id);
            }}
          >
            To Back
          </button>

          <button
            type="button"
            className="dr-quick-menu-item"
            onClick={() => {
              setOpen(false);
              alert(
                object.type === "shape" &&
                  (object.data_json?.shape_type || "") === "custom"
                  ? "For custom shape, use the Move button."
                  : "Drag the object with mouse to move it."
              );
            }}
          >
            Move
          </button>

          <button
            type="button"
            className="dr-quick-menu-item dr-quick-menu-item--danger"
            onClick={() => {
              setOpen(false);
              onDelete?.(object.id);
            }}
          >
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default ObjectQuickMenu;